<template>
	<div>
		<!-- <h2 style="text-align: center;">欢迎进入伴生质子束用户系统</h2> -->
		<div class="p-grid">
			<div class="p-col-12">
				<Card style="margin-bottom: 2em; color: RGB(104,159,56);">
					<template #title>
						<!-- <div><i class="fa fa-pencil-square-o fa-lg"></i><span style="margin-left: .5em">安全培训</span></div> -->
						<div><img src="@/assets/images/kaoshi.png" style="height: 25px; vertical-align: middle;" class="logo" alt="Associated proton"/><span style="margin-left: .5em; color: RGB(237,125,49); vertical-align: middle;">安全培训</span></div>
					</template>
					<template #content>
						<p style="font-size: 1.2em; color: RGB(237,125,49);">在到访CSNS之前，请务必完成有关安全培训项目。</p>
						<a href="https://user.csns.ihep.ac.cn/examing" target="_blank" style="color: RGB(237,125,49); font-size: 1.2em; text-decoration: underline;">点此进入</a>
					</template>
				</Card>
				<Card style="margin-bottom: 2em; color: RGB(104,159,56);">
					<template #title>
						<div><i class="fa fa-pencil-square-o fa-lg"></i><span style="margin-left: .5em">提案申请</span></div>
					</template>
					<template #content>
						<p style="font-size: 1.2em;">用户可以创建和提交提案申请。</p>
						<router-link to="/submission" style="color: RGB(104,159,56); font-size: 1.2em; text-decoration: underline;">点此进入</router-link>
					</template>
				</Card>
				<Card v-if="canRead" style="margin-bottom: 2em; color: RGB(33,150,243)">
					<template #title>
						<div><i class="fa fa-search fa-lg"></i><span style="margin-left: .5em">提案查询</span></div>
					</template>
					<template #content>
						<p style="font-size: 1.2em;">预审核人、审核人和查阅人可以查询所有提案信息。</p>
						<router-link to="/query" style="color: RGB(33,150,243); font-size: 1.2em; text-decoration: underline;">点此进入</router-link>
					</template>
				</Card>
				<Card v-if="canApprove" style="margin-bottom: 2em; color: chocolate">
					<template #title>
						<div><i class="fa fa-check-circle-o fa-lg"></i><span style="margin-left: .5em">提案审核</span></div>
					</template>
					<template #content>
						<p style="font-size: 1.2em;">预审核人和审核人可以对已提交的提案进行审核。</p>
						<router-link to="/approval/toapproveall" style="color: chocolate; font-size: 1.2em; text-decoration: underline;">点此进入</router-link>
					</template>
				</Card>
				<Card v-if="isAdmin" style="margin-bottom: 2em; color: blueviolet">
					<template #title>
						<div><i class="fa fa-cog fa-lg"></i><span style="margin-left: .5em">权限管理</span></div>
					</template>
					<template #content>
						<p style="font-size: 1.2em;">
							<span>管理员可以设置账号权限： </span>
							<router-link to="/usermanagement" style="color: blueviolet; font-size: 1.0em; text-decoration: underline;">点此进入</router-link>
						</p>
						<p style="font-size: 1.2em;">
							<span>管理员可以设置通知公告： </span>
							<router-link to="/noticemanagement" style="color: blueviolet; font-size: 1.0em; text-decoration: underline;">点此进入</router-link>
						</p>
					</template>
				</Card>
				<Card style="margin-bottom: 2em; color: cadetblue">
					<template #title>
						<div><i class="fa fa-info-circle fa-lg"></i><span style="margin-left: .5em">关于</span></div>
					</template>
					<template #content>
						<p style="font-size: 1.2em;">查看软件基本信息。</p>
						<router-link to="/about" style="color: cadetblue; font-size: 1.2em; text-decoration: underline;">点此进入</router-link>
					</template>
				</Card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	mounted() {
		
	},
	created() {
	
	},
	computed: {
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
		canRead() {
            return this.isPreapprover || this.isApprover || this.isReader;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
		isReader() {
			return this.$store.state.authentication.permissions.reader === true;
		},
		isAdmin() {
			return this.$store.state.authentication.permissions.admin === true;
		},
    }

}
</script>

<style scoped>


</style>
